export const subNavItemsToIgnore = ["Logs", "Configuration", "Roles", "Users", "Clients", "Forward Document", "Admissions Inbound", "Payment Hub"];

export const rejectURLAccessForReadOnly: Record<string, boolean> = {
  "Payment Hub": true
}